export default function calculatePercent(value, from) {
  if (!value || !from) return 0
  return Math.round((parseInt(value) / parseInt(from)) * 100)
}
